import { render, staticRenderFns } from "./AddMass.vue?vue&type=template&id=15fdc0e8"
import script from "./AddMass.vue?vue&type=script&lang=ts"
export * from "./AddMass.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports